module.exports = __webpack_public_path__ + "assets/images/img/onboarding_1.17c493f53756bc02eb64213ee4402e5b.png";